import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "services",
  class: "screen"
}
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "wrapper" }
const _hoisted_4 = { class: "intro" }
const _hoisted_5 = { class: "grid-3" }
const _hoisted_6 = { class: "panel" }
const _hoisted_7 = { class: "panel" }
const _hoisted_8 = { class: "panel" }
const _hoisted_9 = { class: "panel" }
const _hoisted_10 = { class: "panel" }

import CommonShapeAnimation from "@/components/common/CommonShapeAnimation.vue";
import CommonButton from "@/components/common/CommonButton.vue";

import IconApp from "@/components/icons/IconApp.vue";
import IconIdentity from "@/components/icons/IconIdentity.vue";
import IconSupport from "@/components/icons/IconSupport.vue";
import IconWeb from "@/components/icons/IconWeb.vue";

import { trackButtonClick } from "@/helpers/analytics.helper";
import { scrollToSection } from "@/helpers/scroll.helper";


export default /*@__PURE__*/_defineComponent({
  __name: 'SectionServices',
  setup(__props) {

const clickHandler = (origin: string, destination: string) => {
    trackButtonClick(`services-${origin}-${destination}`);
    scrollToSection(destination);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(CommonShapeAnimation, {
      shape: "polygon",
      sides: 4,
      rotation: -20,
      position: "left"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[7] || (_cache[7] = _createElementVNode("h2", null, "Nos services", -1)),
          _cache[8] || (_cache[8] = _createElementVNode("p", null, "De l'identité visuelle au digital, en passant par des supports créatifs et des productions audiovisuelles de qualité, nous construisons une communication qui vous ressemble.", -1)),
          _createElementVNode("a", {
            id: "services-header-action",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (clickHandler('header', 'contact'))),
            title: "Contactez-nous"
          }, [
            _createVNode(CommonButton, {
              size: "large",
              icon: "next"
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode("Je me lance", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("article", _hoisted_6, [
            _createElementVNode("header", null, [
              _createVNode(IconIdentity),
              _cache[9] || (_cache[9] = _createElementVNode("h3", null, "Identité visuelle", -1))
            ]),
            _cache[11] || (_cache[11] = _createElementVNode("p", null, [
              _createElementVNode("strong", null, "Concevez l’essence de votre marque.")
            ], -1)),
            _cache[12] || (_cache[12] = _createElementVNode("p", { class: "grow" }, "Nous créons des logos et chartes graphiques qui racontent votre histoire et font forte impression. Construisez une identité qui capte l’attention et inspire la confiance.", -1)),
            _createElementVNode("a", {
              id: "services-identity",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (clickHandler('identity', 'contact'))),
              title: "Contactez-nous"
            }, [
              _createVNode(CommonButton, { icon: "next" }, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createTextVNode("Je me lance", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("article", _hoisted_7, [
            _createElementVNode("header", null, [
              _createVNode(IconSupport),
              _cache[13] || (_cache[13] = _createElementVNode("h3", null, "Supports de communication", -1))
            ]),
            _cache[15] || (_cache[15] = _createElementVNode("p", null, [
              _createElementVNode("strong", null, "Laissez une trace mémorable.")
            ], -1)),
            _cache[16] || (_cache[16] = _createElementVNode("p", { class: "grow" }, "Cartes de visite élégantes, flyers percutants, Devantures qui attirent ou goodies personnalisés… Nous donnons vie à des supports créatifs qui parlent à vos clients et valorisent votre marque.", -1)),
            _createElementVNode("a", {
              id: "services-supports",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (clickHandler('supports', 'contact'))),
              title: "Contactez-nous"
            }, [
              _createVNode(CommonButton, { icon: "next" }, {
                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                  _createTextVNode("Je me lance", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("article", _hoisted_8, [
            _createElementVNode("header", null, [
              _createVNode(IconWeb),
              _cache[17] || (_cache[17] = _createElementVNode("h3", null, "Web", -1))
            ]),
            _cache[19] || (_cache[19] = _createElementVNode("p", null, [
              _createElementVNode("strong", null, "Faites vibrer le digital.")
            ], -1)),
            _cache[20] || (_cache[20] = _createElementVNode("p", { class: "grow" }, "Vous avez besoin d’un site vitrine, une plateforme de réservation, e-commerce ou même une application métier complète ? Nous développons des solutions modernes et performantes, pensées pour vos besoins.", -1)),
            _createElementVNode("a", {
              id: "services-web",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (clickHandler('web', 'contact'))),
              title: "Contactez-nous"
            }, [
              _createVNode(CommonButton, { icon: "next" }, {
                default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                  _createTextVNode("Je me lance", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("article", _hoisted_9, [
            _createElementVNode("header", null, [
              _createVNode(IconApp),
              _cache[21] || (_cache[21] = _createElementVNode("h3", null, "Application mobile", -1))
            ]),
            _cache[23] || (_cache[23] = _createElementVNode("p", null, [
              _createElementVNode("strong", null, "Une expérience utilisateur à portée de main.")
            ], -1)),
            _cache[24] || (_cache[24] = _createElementVNode("p", { class: "grow" }, "Nous imaginons et développons des applications mobiles intuitives, prêtes à engager vos utilisateurs et à renforcer votre présence.", -1)),
            _createElementVNode("a", {
              id: "services-app",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (clickHandler('app', 'contact'))),
              title: "Contactez-nous"
            }, [
              _createVNode(CommonButton, { icon: "next" }, {
                default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                  _createTextVNode("Je me lance", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("article", _hoisted_10, [
            _createElementVNode("header", null, [
              _createVNode(IconWeb),
              _cache[25] || (_cache[25] = _createElementVNode("h3", null, "Photo & vidéo", -1))
            ]),
            _cache[27] || (_cache[27] = _createElementVNode("p", null, [
              _createElementVNode("strong", null, "Racontez votre histoire en images.")
            ], -1)),
            _cache[28] || (_cache[28] = _createElementVNode("p", { class: "grow" }, "Produits, événements, vidéos institutionnelles… Nous capturons l’essence de votre activité avec des visuels professionnels qui marquent les esprits.", -1)),
            _createElementVNode("a", {
              id: "services-photo-video",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (clickHandler('photo-video', 'contact'))),
              title: "Contactez-nous"
            }, [
              _createVNode(CommonButton, { icon: "next" }, {
                default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                  _createTextVNode("Je me lance", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})